import { Component, inject } from '@angular/core';
import { ConfigurableDialog, DialogService, DialogModule } from '@proget-shared/dialog';
import { InputModule } from '@proget-shared/form/input';
import { TranslateModule } from '@proget-shared/translate';
import { CopyToClipboardModule } from '@proget-shared/ui/copy-to-clipboard';

@Component({
  selector: 'lib-set-password-url',
  templateUrl: './set-password-url.component.html',
  imports: [
    CopyToClipboardModule,
    DialogModule,
    InputModule,
    TranslateModule,
  ],
})
export class SetPasswordUrlComponent implements ConfigurableDialog {
  protected url = '';

  private readonly dialog = inject(DialogService);

  onConfiguration(configuration: any): void {
    this.url = configuration.url || '';
  }

  protected close(): void {
    this.dialog.resolve(this);
  }
}
